module.exports = __webpack_public_path__ + "static/gallery19-15ef08b415405fd1ce0348a1d55b6f39.jpg";